export { default } from '@esentai/core/features/locations/api';
